import { useSelector } from 'react-redux'

import { stepTypeDefaultsSelector } from '../../flow/selectors/stepTypeDefaultsSelector'

export function useStepTypeDefaults() {
  return useSelector(stepTypeDefaultsSelector)
}
